(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  /* ============ Helpers ============ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function splitTitle(title) {
    var parts = title.split('\u2013');
    return parts.length > 1 ? parts[0].trim() : title;
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ============ Header scroll state ============ */
  var header = qs('[data-site-header]');
  if (header) {
    var heroEl = qs('[data-hero]');
    var threshold = heroEl ? heroEl.offsetHeight - 80 : 80;
    function onScroll() {
      if (window.scrollY > threshold) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============ Mobile nav ============ */
  var navToggle = qs('.nav-toggle');
  var mobileNav = qs('#MobileNav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ============ Reveal on scroll ============ */
  var revealEls = qsa('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============ Drawers (generic open/close) ============ */
  function openDrawer(drawer) {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  qsa('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeDrawer(qs('#CartDrawer')); });
  });
  qsa('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openDrawer(qs('#CartDrawer')); });
  });
  qsa('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeDrawer(qs('#SearchDrawer')); });
  });
  qsa('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = qs('#SearchDrawer');
      openDrawer(drawer);
      var input = qs('#SearchDrawerInput');
      if (input) setTimeout(function () { input.focus(); }, 100);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      qsa('.drawer[aria-hidden="false"]').forEach(closeDrawer);
      var qa = qs('#QuickAddModal');
      if (qa && !qa.hidden) closeQuickAdd();
      var sg = qs('#SizeGuideModal');
      if (sg && !sg.hidden) sg.hidden = true;
    }
  });

  /* ============ Cart: render + AJAX ============ */
  var cartDrawer = qs('#CartDrawer');

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var body = qs('[data-cart-items]', cartDrawer);
    var footer = qs('[data-cart-footer]', cartDrawer);
    var subtotal = qs('[data-cart-subtotal]', cartDrawer);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty" data-cart-empty><p>Your bag is empty.</p><a href="/collections/all" class="btn btn--outline" data-cart-close>Continue shopping</a></div>';
      if (footer) footer.hidden = true;
    } else {
      body.innerHTML = cart.items.map(function (item) {
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
        return '' +
          '<div class="cart-line" data-cart-line data-line-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-line__image">' + (item.image ? '<img src="' + item.image + '&width=200" alt="" width="100">' : '') + '</a>' +
            '<div class="cart-line__info">' +
              '<a href="' + item.url + '" class="cart-line__title">' + splitTitle(item.product_title) + '</a>' +
              variantLine +
              '<div class="cart-line__qty" data-quantity-selector>' +
                '<button type="button" data-quantity-decrease aria-label="Decrease quantity">&minus;</button>' +
                '<span data-quantity-value>' + item.quantity + '</span>' +
                '<button type="button" data-quantity-increase aria-label="Increase quantity">&plus;</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-line__end">' +
              '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
              '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove item">&times;</button>' +
            '</div>' +
          '</div>';
      }).join('');
      if (footer) footer.hidden = false;
    }
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var fill = qs('[data-cart-shipping-fill]', cartDrawer);
    var text = qs('[data-cart-shipping-text]', cartDrawer);
    var threshold = window.ForHis && window.ForHis.freeShippingThreshold;
    if (fill && threshold) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      fill.style.width = pct + '%';
      if (text) {
        var remaining = threshold - cart.total_price;
        text.innerHTML = remaining > 0
          ? "You're <strong>" + formatMoney(remaining) + '</strong> away from free shipping'
          : "You've unlocked free shipping";
      }
    }
    bindCartLineEvents();
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  function bindCartLineEvents() {
    qsa('[data-cart-line]', cartDrawer).forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qtyEl = qs('[data-quantity-value]', line);
      var dec = qs('[data-quantity-decrease]', line);
      var inc = qs('[data-quantity-increase]', line);
      var remove = qs('[data-cart-remove]', line);
      if (dec) dec.addEventListener('click', function () {
        var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
        changeLine(key, newQty);
      });
      if (inc) inc.addEventListener('click', function () {
        changeLine(key, parseInt(qtyEl.textContent, 10) + 1);
      });
      if (remove) remove.addEventListener('click', function () { changeLine(key, 0); });
    });
  }
  bindCartLineEvents();

  function addToCart(formData, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        openDrawer(cartDrawer);
        if (onDone) onDone();
      })
      .catch(function () { if (onDone) onDone(); });
  }

  /* Intercept the main product-page add-to-cart form */
  var addToCartForm = qs('#AddToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = qs('[data-add-to-cart]', addToCartForm);
      var originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      addToCart(new FormData(addToCartForm), function () {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
      });
      if (window.ForHis && window.ForHis.currentProductHandle) {
        trackRecentlyViewed(window.ForHis.currentProductHandle);
      }
    });
  }

  /* ============ Product page: variant picker, gallery, zoom ============ */
  if (addToCartForm && window.productVariants) {
    var variants = window.productVariants;
    var selected = {};
    var optionGroups = qsa('.option-selector', addToCartForm);

    optionGroups.forEach(function (group, idx) {
      var buttons = qsa('.option-value', group);
      buttons.forEach(function (btn, bIdx) {
        if (bIdx === 0) { btn.classList.add('is-selected'); selected[idx] = btn.dataset.value; }
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selected[idx] = btn.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (opt, i) {
          return selected[i] === undefined || opt === selected[i];
        });
      });
      if (!match) return;
      var idInput = qs('[data-variant-id]', addToCartForm);
      var priceEl = qs('[data-product-price]');
      var addPriceEl = qs('[data-add-to-cart-price]');
      var addBtn = qs('[data-add-to-cart]', addToCartForm);
      idInput.value = match.id;
      var html = formatMoney(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html += ' <s>' + formatMoney(match.compare_at_price) + '</s>';
      }
      if (priceEl) priceEl.innerHTML = html;
      if (addPriceEl) addPriceEl.textContent = formatMoney(match.price);
      if (addBtn) addBtn.disabled = !match.available;
    }
    updateVariant();
  }

  /* Quantity stepper on product page */
  var qtyDecrease = qs('[data-qty-decrease]');
  var qtyIncrease = qs('[data-qty-increase]');
  var qtyInput = qs('#Quantity');
  if (qtyDecrease && qtyInput) qtyDecrease.addEventListener('click', function () {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1);
  });
  if (qtyIncrease && qtyInput) qtyIncrease.addEventListener('click', function () {
    qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1;
  });

  /* Gallery thumbs */
  qsa('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.getAttribute('data-index');
      qsa('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      qsa('[data-gallery-slide]').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-index') === index);
      });
    });
  });

  /* Hover zoom on main product image */
  qsa('[data-zoom]').forEach(function (zoomEl) {
    var img = qs('img', zoomEl);
    zoomEl.addEventListener('mousemove', function (e) {
      var rect = zoomEl.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      if (img) img.style.transformOrigin = x + '% ' + y + '%';
      zoomEl.classList.add('is-zoomed');
    });
    zoomEl.addEventListener('mouseleave', function () { zoomEl.classList.remove('is-zoomed'); });
  });

  /* Size guide modal */
  var sizeGuideModal = qs('#SizeGuideModal');
  qsa('[data-size-guide-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (sizeGuideModal) sizeGuideModal.hidden = false;
    });
  });
  qsa('[data-size-guide-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (sizeGuideModal) sizeGuideModal.hidden = true; });
  });

  /* ============ Quick add modal ============ */
  var quickAddModal = qs('#QuickAddModal');
  var quickAddContent = qs('#QuickAddContent');
  function closeQuickAdd() { if (quickAddModal) quickAddModal.hidden = true; }
  qsa('[data-quick-add-close]').forEach(function (btn) { btn.addEventListener('click', closeQuickAdd); });

  qsa('[data-quick-add-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-handle');
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (product) {
        renderQuickAdd(product);
        quickAddModal.hidden = false;
      });
    });
  });

  function renderQuickAdd(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var firstVariant = product.variants[0];
    var optionsHtml = product.options.map(function (optionName, idx) {
      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (idx + 1)];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      var buttonsHtml = values.map(function (val, vIdx) {
        return '<button type="button" class="option-value' + (vIdx === 0 ? ' is-selected' : '') + '" data-qa-option-index="' + idx + '" data-value="' + val + '">' + val + '</button>';
      }).join('');
      return '<div class="option-selector"><label class="option-label">' + optionName + '</label><div class="option-values">' + buttonsHtml + '</div></div>';
    }).join('');

    quickAddContent.innerHTML =
      (image ? '<img class="quick-add-content__image" src="' + image + '&width=600" alt="">' : '') +
      '<h3 class="quick-add-content__title">' + splitTitle(product.title) + '</h3>' +
      '<p class="quick-add-content__price" data-qa-price>' + formatMoney(firstVariant.price) + '</p>' +
      optionsHtml +
      '<button type="button" class="btn btn--full" data-qa-add' + (firstVariant.available ? '' : ' disabled') + '>' + (firstVariant.available ? 'Add to bag' : 'Sold out') + '</button>';

    var qaSelected = {};
    product.options.forEach(function (name, idx) { qaSelected[idx] = product.variants[0]['option' + (idx + 1)]; });

    function qaUpdate() {
      var match = product.variants.find(function (v) {
        return Object.keys(qaSelected).every(function (i) { return v['option' + (parseInt(i, 10) + 1)] === qaSelected[i]; });
      });
      if (!match) return;
      var priceEl = qs('[data-qa-price]', quickAddContent);
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      var addBtn = qs('[data-qa-add]', quickAddContent);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        addBtn.onclick = function () {
          var fd = new FormData();
          fd.append('id', match.id);
          fd.append('quantity', 1);
          addBtn.textContent = 'Adding...';
          addToCart(fd, function () { closeQuickAdd(); });
        };
      }
    }

    qsa('[data-qa-option-index]', quickAddContent).forEach(function (optBtn) {
      optBtn.addEventListener('click', function () {
        var idx = optBtn.getAttribute('data-qa-option-index');
        qsa('[data-qa-option-index="' + idx + '"]', quickAddContent).forEach(function (b) { b.classList.remove('is-selected'); });
        optBtn.classList.add('is-selected');
        qaSelected[idx] = optBtn.getAttribute('data-value');
        qaUpdate();
      });
    });
    qaUpdate();
  }

  /* ============ Wishlist (localStorage) ============ */
  var WISHLIST_KEY = 'forhis_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistUI();
  }
  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1); else list.push(handle);
    setWishlist(list);
  }
  function updateWishlistUI() {
    var list = getWishlist();
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var saved = list.indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', String(saved));
    });
  }
  qsa('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWishlist(btn.getAttribute('data-handle'));
    });
  });
  updateWishlistUI();

  /* Wishlist page rendering */
  var wishlistGrid = qs('[data-wishlist-grid]');
  if (wishlistGrid) {
    var savedHandles = getWishlist();
    var emptyMsg = qs('[data-wishlist-empty]');
    if (savedHandles.length === 0) {
      if (emptyMsg) emptyMsg.hidden = false;
    } else {
      Promise.all(savedHandles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = products.filter(Boolean).map(productCardHtml).join('');
        wishlistGrid.innerHTML = html;
        if (!html && emptyMsg) emptyMsg.hidden = false;
      });
    }
  }

  function productCardHtml(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var price = product.price_min !== undefined ? product.price_min : product.price;
    return '' +
      '<div class="product-card" data-product-handle="' + product.handle + '">' +
        '<a href="/products/' + product.handle + '" class="product-card__media">' +
          (image ? '<img class="product-card__img product-card__img--front" src="' + image + '&width=900" alt="">' : '') +
        '</a>' +
        '<button type="button" class="product-card__wishlist" data-wishlist-toggle data-handle="' + product.handle + '" aria-pressed="true" aria-label="Remove from wishlist">&hearts;</button>' +
        '<div class="product-card__info">' +
          '<a href="/products/' + product.handle + '" class="product-card__title">' + splitTitle(product.title) + '</a>' +
          '<p class="product-card__price">' + formatMoney(price) + '</p>' +
        '</div>' +
      '</div>';
  }

  /* ============ Recently viewed ============ */
  var RECENT_KEY = 'forhis_recently_viewed';
  function trackRecentlyViewed(handle) {
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 8);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  if (window.ForHis && window.ForHis.currentProductHandle) {
    trackRecentlyViewed(window.ForHis.currentProductHandle);
  }

  var recentlyViewedSection = qs('[data-recently-viewed]');
  if (recentlyViewedSection) {
    var recentGrid = qs('[data-recently-viewed-grid]', recentlyViewedSection);
    var currentHandle = window.ForHis && window.ForHis.currentProductHandle;
    var recentList = [];
    try { recentList = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) {}
    recentList = recentList.filter(function (h) { return h !== currentHandle; }).slice(0, 4);

    if (recentList.length) {
      Promise.all(recentList.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var html = products.filter(Boolean).map(productCardHtml).join('');
        if (html) {
          recentGrid.innerHTML = html;
          recentlyViewedSection.hidden = false;
        }
      });
    }
  }

  /* ============ Predictive search ============ */
  var searchInput = qs('#SearchDrawerInput');
  var searchResults = qs('#SearchDrawerResults');
  var searchTimer = null;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      if (term.length < 2) {
        searchResults.innerHTML = '<p class="search-drawer__hint">Try "Made New", "Blessed Hope", or a verse like "Philippians 4:13"</p>';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="search-drawer__hint">No results for "' + term + '"</p>';
              return;
            }
            searchResults.innerHTML = '<div class="search-result-grid">' + products.map(function (p) {
              return '' +
                '<a href="' + p.url + '" class="product-card">' +
                  '<span class="product-card__media">' + (p.featured_image ? '<img class="product-card__img product-card__img--front" src="' + p.featured_image.url + '&width=400" alt="">' : '') + '</span>' +
                  '<span class="product-card__info"><span class="product-card__title">' + splitTitle(p.title) + '</span><span class="product-card__price">' + p.price + '</span></span>' +
                '</a>';
            }).join('') + '</div>';
          });
      }, 280);
    });
  }

  /* ============ Drop countdown ============ */
  qsa('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-target')).getTime();
    if (isNaN(target)) return;
    var daysEl = qs('[data-countdown-days]', el);
    var hoursEl = qs('[data-countdown-hours]', el);
    var minutesEl = qs('[data-countdown-minutes]', el);
    var secondsEl = qs('[data-countdown-seconds]', el);
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  });

  /* ============ Carousels ============ */
  qsa('[data-carousel]').forEach(function (carousel) {
    var track = qs('[data-carousel-track]', carousel);
    var wrapper = carousel.closest('.section, .container').parentElement || carousel.parentElement;
    var prevBtn = qs('[data-carousel-prev]', wrapper);
    var nextBtn = qs('[data-carousel-next]', wrapper);
    if (!track) return;
    var scrollAmount = function () { return track.clientWidth * 0.8; };
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });

  /* ============ Consent banner ============ */
  var consentBanner = qs('[data-consent-banner]');
  if (consentBanner) {
    var CONSENT_KEY = 'forhis_consent';
    var existing = localStorage.getItem(CONSENT_KEY);
    if (!existing) {
      setTimeout(function () { consentBanner.hidden = false; }, 600);
    }
    var acceptBtn = qs('[data-consent-accept]', consentBanner);
    var declineBtn = qs('[data-consent-decline]', consentBanner);
    if (acceptBtn) acceptBtn.addEventListener('click', function () {
      localStorage.setItem(CONSENT_KEY, 'accepted');
      consentBanner.hidden = true;
    });
    if (declineBtn) declineBtn.addEventListener('click', function () {
      localStorage.setItem(CONSENT_KEY, 'declined');
      consentBanner.hidden = true;
    });
  }

  /* ============ Free shipping threshold from settings ============ */
  var shippingBar = qs('[data-cart-shipping-bar]');
  if (shippingBar) {
    var fillEl = qs('[data-cart-shipping-fill]', shippingBar);
    if (fillEl) {
      window.ForHis = window.ForHis || {};
    }
  }
})();
